import React, { useState } from 'react';
import { Grid, Box, Typography, Divider, Tabs, Tab } from '@mui/material';
import { makeStyles } from '@mui/styles';
import TriggerSettings from './triggerSettings';
import FlowSettings from './flowSettings';
import FileSetup from './fileSetup';
import VendorSetup from './vendorSetup';
import ChannelActions from './channelActions/channelActions';
import CacheSetting from './cacheSetting/index';

const useStyles = makeStyles({
    tabs: {
        "& .MuiTabs-indicator": {
            backgroundColor: "#733567",
            height: 2,
        },
        "& .MuiTab-root.Mui-selected": {
            color: '#733567'
        }
    }
})

const ADMIN_SETTINGS = ['Trigger Settings', 'Flows Settings', 'File Setup', 'Vendor Setup','Actions','Cache Setting'];

const CustomTabPanel = (props) => {
    const { children, value, index, ...other } = props;

    const renderTabComponent = (selectedSetting) => {
        switch (selectedSetting) {
            case 0:
                return <TriggerSettings />;
            case 1:
                return <FlowSettings />;
            case 2:
                return <FileSetup />;
            case 3:
                return <VendorSetup />;
            case 4:
                return <ChannelActions/>;
            case 5: 
                return <CacheSetting/>    
            
            default:
                return null;
        }
    };

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {renderTabComponent(value)}
                </Box>
            )}
        </div>
    );
};

const a11yProps = (index) => {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
};

const AdminSettings = (props) => {
    const classes = useStyles();

    const [selectedSetting, setSelectedSetting] = useState(0);

    const handleSelectedSettingChange = (event, value) => {
        setSelectedSetting(value);
    };



    return (
        <Grid container className="flex-row" spacing={'24px'}>
            {/* Admin Settings */}
            <Grid item xs={12}>
                <Box className="flex-column gap-20">
                    <Typography className="text-lg-medium gray-900">
                        Admin Settings
                    </Typography>
                    <Box className="border-bottom-gray">
                        <Tabs
                            value={selectedSetting}
                            onChange={handleSelectedSettingChange}
                            className={classes.tabs}
                        >
                            {ADMIN_SETTINGS?.map((setting, index) => (
                                <Tab
                                    label={
                                        <Typography className="text-sm-medium">
                                            {setting}
                                        </Typography>
                                    }
                                    {...a11yProps(index)}
                                    key={index}
                                    sx={{
                                        textTransform: 'none',
                                    }}
                                />
                            ))}
                        </Tabs>
                    </Box>
                </Box>

                <CustomTabPanel value={selectedSetting} index={0} >
                    <TriggerSettings />
                </CustomTabPanel>
                <CustomTabPanel value={selectedSetting} index={1} >
                    <FlowSettings />
                </CustomTabPanel>
                <CustomTabPanel value={selectedSetting} index={2} >
                    <FileSetup />
                </CustomTabPanel>
                <CustomTabPanel value={selectedSetting} index={3} >
                    <VendorSetup />
                </CustomTabPanel>
                <CustomTabPanel value={selectedSetting} index={4} >
                    <ChannelActions />
                </CustomTabPanel>
                <CustomTabPanel value={selectedSetting} index={5} >
                    <CacheSetting />
                </CustomTabPanel>
            </Grid>
        </Grid>
    );
};

export default AdminSettings;
